import { model } from "../core/model";
import view from "../helpers/view";
import { nav, nav2 } from "./nav";
import { tiene_deuda, tiene_deuda_embed } from "./tiene_deuda";
import { mostrar_error } from "./error";
import { no_acceso_pdf,no_acceso_pdf_embed } from "./pdf_suscripto_sin_acceso";
import Analitycs from '../helpers/analytics'
import { remainingTime } from "./remainingTime";

const trackPage = true;

const config = {
    NAV: {
        div: "#nav",
        fview: nav,
        fview_embed: nav,
    },
    NAV_BOTTOM: {
        div: "#nav-bottom",
        fview: nav,
        fview_embed: nav,
    },
    NAV2: {
        div: "#nav2",
        fview: nav2,
        fview_embed: nav2,
    },
    TIENE_DEUDA:{
        div: ".container",
        fview: tiene_deuda,
        fview_embed: tiene_deuda_embed,
        trackPage,
    },
    MOSTRAR_ERROR: {
        div: ".container",
        fview: mostrar_error,
        trackPage,
    },
    PDF_SUSCRIPTO_SIN_ACCESO:{
        div: ".container",
        fview: no_acceso_pdf,
        fview_embed: no_acceso_pdf_embed,
        trackPage,
    },
    REMAINING_TIME: {
        div: "#remaining-time__time",
        fview: remainingTime,
    },
}

export default (name, params, callback) => {
    name = name.toUpperCase();
    if (name && config[name] && config[name].div && config[name].fview) {
        if (model.Embed.Mobile && config[name].fview_embed) {
            view.apply(config[name].div, config[name].fview_embed(params));
        }
        else {
            //console.log(config[name].div)
            view.apply(config[name].div,config[name].fview(params));
        }
        callback && callback(params);
        if (config[name].trackPage)
        {
            Analitycs.paginaVirtual(model.Window)
        }
    }
    else {
        console.log('no se encontro la vista o esta mal configurada')
    }
}



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/index.js